<template>
  <div class="communities-container">
    <div class="tiles-container" v-if="communities.length > 0">
      <div
        v-for="community in communities"
        :key="community.id"
        class="community-block"
        data-cy="community-card"
      >
        <div class="reported-block">
          <community-tile :community="community" />
        </div>
      </div>
    </div>
    <div v-if="communities.length === 0 && loaded">
      <div class="no-results">
        {{ $t('administrator.reportedCommunities.noReportedCommunities') }}
      </div>
      <logo-background />
    </div>
  </div>
</template>

<script>
import CommunityTile from '../community/CommunityTile'
import LogoBackground from '@/components/shared/LogoBackground'

export default {
  name: 'ReportedCommunities',
  components: { CommunityTile, LogoBackground },
  data () {
    return {
      communityNameSearch: '',
      loaded: false
    }
  },
  async created () {
    await this.$store.dispatch('fetchReportedCommunities')
    this.loaded = true
  },
  methods: {
    resetSearch () {
      this.communityNameSearch = ''
    }
  },
  computed: {
    communities () {
      return this.$store.getters.reportedCommunities
    }
  }
}
</script>

<style scoped lang="scss">

.communities-container {
    width: 1250px;
    margin-top: 20px;
    max-width: 100vw;
    .down {
        #list {
            top: 270px !important;
        }
    }
}

.tiles-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;

  @media (max-width: 1247.5px) {
    justify-content: center;
    margin-bottom: 50px;
  }
}

.community-block {
  margin: 10px;
  height: 434px;

  @media (max-width: $small) {
    max-width: 100%;
    margin: 10px auto 10px auto;

  }
}

.reported-block {
  height: 100%;
  width: 100%;
  margin: 10px auto;
  background: white;
  display: flex;
  cursor: pointer;
  text-align: center;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);

    &:hover {
      box-shadow: 2px 2px 30px 0 rgba(3, 3, 3, 0.2);
    }

    img {
        width: 100%;
        height: auto;
    }
}

</style>
